import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';
import { formatValue, setCaret } from '@/common/format';
import util from '@/common/util';
import Autocomplete from '@/components/map-here/js/autocomplete';


export default {
    props: {
        placeholder: {
            type: String,
            default: undefined
        },
        inputBoderColor: {
            type: String,
            default: ''
        },
        submitText: {
            type: String,
            default: 'Submit'
        },
        submitStyle: {
            type: Object,
            default: () => ({})
        },
        country: {
            type: String,
            default: ''
        },
        showUnitField: {
            type: Boolean,
            default: false
        },
        autoFocus: {
            type: Boolean,
            default: true
        },
        chooseSuggestionAutoSubmit: {
            type: Boolean,
            default: false
        },
        autoMatchSuggestion: {
            type: Boolean,
            default: false
        },
        mobileScroll: {
            type: Boolean,
            default: true
        },
        icon: {
            type: String,
            default: ''
        },
        searchText: {
            type: String,
            default: ''
        },
        submitBtnStyle: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            address: '', // input v-model
            unit: '',
            errorShow: false,
            submitDisabled: false
        };
    },
    watch: {
        address() {
            this.$emit('update:searchText', this.address);
        },
        searchText: {
            immediate: true,
            handler: function() {
                this.address = this.searchText;
            }
        }
    },
    computed: {
        ...rootMapState(usePageStore, {
            "page": store => store.page,
            "currencySymbol": store => store.currency.symbol
        }),
        
        isMobile() {
            return this.platform.isMobile;
        },
        compCountry({ page }) {
            return this.country || page.country || 'usa';
        }
    },
    methods: {
        addressFormat(value, doInput = false) {
            let result = formatValue(this.$refs.input, {
                oldValue: this.address,
                value: value,
                mask: 'search',
                currencySymbol: this.currencySymbol
            });
            if (!result) {
                return value;
            }
            if (doInput) {
                this.$nextTick(() => setCaret(this.$refs.input, result.caret));
            }
            return result.value;
        },
        //  initialization  autocomplete( about to input -> autocomplete)
        initAutocomplete() {
            if (!this.autocomplete) {
                // Autocomplete()  exist  input Carried on autoComplete package of (suggestions The business logic is also encapsulated inside )
                // this.autocomplete = {getPlace,getSuggestion}
                this.autocomplete = Autocomplete(
                    this.$refs.input,
                    this.compCountry,
                    //  chosen suggestion callback after 
                    () => {
                        this.address = this.$refs.input.value;
                        if (this.chooseSuggestionAutoSubmit || this.isMobile) {
                            //  Auto trigger on mobile 
                            if (this.inPop) {
                                //  Indicates that it is operating in a pop-up window 
                                this.onSubmit(true);
                            } else {
                                this.onSubmit(false);
                            }
                        }
                    }
                );
            }
        },
        // input focus
        onFocus() {
            !this.autocomplete && this.initAutocomplete();
            if (this.isMobile && this.mobileScroll) {
                this.$refs.input &&
                    this.$refs.input.scrollIntoView({
                        block: 'center',
                        inline: 'nearest'
                    });
                // util.scrollIntoView(this.$refs.input, true);
                let num = 0;
                util.timeout({
                    handler: () => {
                        if (num === 5) {
                            return false; 
                        }
                        this.$refs.input &&
                            this.$refs.input.scrollIntoView({
                                block: 'center',
                                inline: 'nearest'
                            });
                        // util.scrollIntoView(this.$refs.input, true);
                        num += 1;
                    },
                    once: false,
                    delay: 50
                });
            }
            this.$emit('focus');
        },
        onUnitFocus() {
            this.$emit('focus');
        },
        onInput($event) {
            if (!this.lockedInput) {
                this.address = this.addressFormat($event.target.value, true);
            }
        },
        onCompositionstart() {
            this.lockedInput = true;
        },
        onCompositionend($event) {
            this.lockedInput = false;
            this.address = this.addressFormat($event.target.value, true);
        },
        onBlur() {
            this.$emit('blur');
        },
        onKeyDown($event, isPop = false) {
            const code = $event.keyCode;
            if (code === 13) {
                $event.preventDefault();
                this.onSubmit(isPop);
                this.autocomplete.close();
            }
        },
        //  monitor submit event 
        onSubmit(isPop = false) {
            // isPop  Indicates whether to operate in the pop-up window 
            const address = this.$refs.input.value.trim();
            if (address) {
                this.submitDisabled = true;
                setTimeout(() => {
                    this.submitDisabled = false;
                }, 2000);
                this.submitAddress(address, isPop);
            }
        },
        submitAddress(address, isPop) {
            this.$refs.input.blur();
            if (isPop) {
                this.onConfirm(address, () => {
                    this.clearAddress();
                    this.onClose();
                });
            } else {
                this.handleSearch(address, () => {
                    this.clearAddress();
                });
            }
        },
        showError() {
            this.errorShow = true;
            util.timeout({
                handler: () => {
                    this.errorShow = false;
                },
                delay: 3000,
                unique: true
            });
        },
        clearAddress() {
            this.address = '';
            this.autocomplete && this.autocomplete.close();
        }
    }
};
